<template>
  <div class="datepickercell">
    <!-- <h1>{{this.$attrs.datee}}</h1> -->
    <v-date-picker
      no-title
      v-model="value"
      multiple
      hide-header
      :range="$attrs.semester.rangeable"
      @click:date="dblClick"
      first-day-of-week="1"
      :picker-date.sync="pickerDate"
    ></v-date-picker>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../../firebaseConfig.js");

export default {
  data: () => ({
    pickerDate: null,
    value: null,
  }),

  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  created() {
    this.value = [this.$attrs.datee];
    if (this.$attrs.semester.excludedDays) {
      for (var xx of this.$attrs.semester.excludedDays) {
        var mm = new Date(xx).getMonth();
        if (mm == new Date(this.$attrs.datee).getMonth()) this.value.push(xx);
      }
    }
  },
  mounted() {
    this.value = [this.$attrs.datee];
    if (this.$attrs.semester.excludedDays) {
      for (var xx of this.$attrs.semester.excludedDays) {
        var mm = new Date(xx).getMonth();
        if (mm == new Date(this.$attrs.datee).getMonth()) this.value.push(xx);
      }
    }
  },
  methods: {
    dblClick(e) {
      if (
        this.$attrs.semester.excludedDays == undefined ||
        this.$attrs.semester.excludedDays == null
      )
        this.$attrs.semester.excludedDays = [];
      var foundIndex = -1;
      var counter = 0;
      for (var xx of this.$attrs.semester.excludedDays) {
        if (xx == e) {
          foundIndex = counter;
          break;
        }
        counter++;
      }
      if (foundIndex == -1) {
        this.$attrs.semester.excludedDays.push(e);
      } else {
        this.$attrs.semester.excludedDays.splice(foundIndex, 1);
      }
      this.$attrs.semester.ref.update({
        excludedDays: this.$attrs.semester.excludedDays,
        rangeable: this.$attrs.semester.rangeable,
      });
    },
    myDate(e) {
      console.log(this.$attrs.semester);
      console.log(e);
      console.log(this.value);
    },
  },
};
</script>
<style >
/* .v-date-picker-header {
  display: none;
} */
.datepickercell .v-date-picker-header__value {
  pointer-events: none;
}

.datepickercell .v-date-picker-header .v-btn {
  display: none;
}
.datepickercell .date-color {
  color: #00b300;
  font-weight: 900;
}

.datepickercell .v-btn--active .date-color {
  color: #fff;
}
</style>